import { render, staticRenderFns } from "./island.vue?vue&type=template&id=0c0883bf&scoped=true&"
var script = {}
import style0 from "./island.vue?vue&type=style&index=0&id=0c0883bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0883bf",
  null
  
)

export default component.exports